import Vue from 'vue';

export const Bus = new Vue();

const plugin = {
  install() {
    Vue.bus = Bus;
    Vue.prototype.$bus = Bus;
  },
};
window.$bus = Bus;

Vue.use(plugin);
